export default function Loader() {
  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <div className="relative w-12 h-12 mx-auto my-5 bg-[#353535] animate-[spin_1s_ease-in-out_infinite_reverse] before:content-[''] before:absolute before:w-12 before:h-12 before:bg-[#2e2e2e] before:top-0 before:left-0 before:rotate-45 before:shadow-[0_0_5px_rgba(0,0,0,0.15)] after:content-[''] after:absolute after:w-8 after:h-8 after:rounded-full after:bg-black after:left-1/2 after:top-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:shadow-[0_0_5px_rgba(0,0,0,0.15)]"></div>
    </div>
  );
}
